export default "f4ffa8f053a1ed67.ttf"